import { render, staticRenderFns } from "./similarGoodsList.vue?vue&type=template&id=3bedd3a2&scoped=true"
import script from "./similarGoodsList.vue?vue&type=script&lang=js"
export * from "./similarGoodsList.vue?vue&type=script&lang=js"
import style0 from "./similarGoodsList.vue?vue&type=style&index=0&id=3bedd3a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bedd3a2",
  null
  
)

export default component.exports